import LimitUsageBar from "../LimitUsageBar";
import LimitUsageViewer from "../LimitUsageViewer";
import { jsx as _jsx } from "react/jsx-runtime";
const CountLimitUsageViewer = _ref => {
  let {
    availableAsPercentage = false,
    label,
    limit,
    sharedWith,
    unit = null,
    used = null
  } = _ref;
  let available = used > limit ? 0 : limit - used;
  if (available < 0) available = 0;
  const progress = used > limit || limit === 0 ? 1 : used / limit;
  return /*#__PURE__*/_jsx(LimitUsageViewer, {
    limit: unit ? `${limit} ${unit}` : limit,
    label: label,
    sharedWith: sharedWith,
    usage: used !== null && /*#__PURE__*/_jsx(LimitUsageBar, {
      availableDesc: `${availableAsPercentage ? `${Math.round(100 - progress * 100)}%` : available} available`,
      progress: progress,
      usedDesc: `${Math.round(used)}${unit ? ` ${unit}` : ''} used`
    }),
    "data-sentry-element": "LimitUsageViewer",
    "data-sentry-component": "CountLimitUsageViewer",
    "data-sentry-source-file": "CountLimitUsageViewer.tsx"
  });
};
export default CountLimitUsageViewer;